<template>
  <div class="stats-wrap">
    <div class="stats">
      <div class="stat">
        <p class="stat-label">
          Sends
        </p>
        <p class="stat-data">
          {{ sentCount }}
        </p>
      </div>

      <div class="stat">
        <p class="stat-label">
          Opens
        </p>
        <p class="stat-data">
          {{ openCount }}
        </p>
      </div>

      <div class="stat">
        <p class="stat-label">
          Clicks
        </p>
        <p class="stat-data">
          {{ clickCount }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignListStats",
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sentCount() {
      return this.campaign?.stats?.sentCount ?? "-";
    },
    openCount() {
      return this.campaign?.stats?.openCount ?? "-";
    },
    clickCount() {
      return this.campaign?.stats?.clickCount ?? "-";
    },
  },
};
</script>

<style scoped>
.stats-wrap {
  @apply w-full;

  @screen lg {
    @apply max-w-xs;
  }
}

.stats {
  @apply flex bg-brand-light p-4 rounded-lg w-full mt-6 bg-white border border-grey-lighter max-w-xs mx-auto;
  border-color: #f1f1f1;
  background: linear-gradient(
    160deg,
    rgba(254, 254, 254, 1) 0%,
    rgba(252, 252, 252, 1) 100%
  );

  @screen lg {
    @apply m-0;
  }
}

.stat {
  @apply flex-1 text-center;
}

.stat-label {
  @apply m-0 text-xs text-support-light;

  @screen lg {
    @apply text-sm;
  }
}

.stat-data {
  @apply m-0 font-bold font-lato text-support text-sm;

  @screen lg {
    @apply text-base;
  }
}
</style>
